import { PatientClinicId } from '@app/icare/entities/patient/schema/PatientClinic'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientClinicOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_clinic/-components/PatientClinicOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_clinic/kliniken/$relation')({
  params: entityParams({ id: PatientId, relation: PatientClinicId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientClinicOverview patientId={id} relationId={relation} />
}
